module.exports = __webpack_public_path__ + "img/xn.21e4aabf.jpg";